import React from 'react';
import PropTypes from 'prop-types';
import Constants from '../../../../model/AppConfiguration';
import SelectedMealListItem from '../../../../components/meals/selectedMealListItem/SelectedMealListItem';
import Dictionary from '../../../../model/Dictionary';

const SelectedMealListItems = ({ passenger, meals, className }) =>
  meals.category.map(meal => {
    let label = meal.label.toLowerCase();
    switch (label) {
      case Constants.MEAL.APPETIZER:
        return (
          <SelectedMealListItem
            key={`selected-meal-list-item-${Constants.MEAL.APPETIZER}-${passenger.id}`}
            className={className}
            passenger={passenger}
            meal={meal}
            mealType={Constants.MEAL.APPETIZER}
            label={Dictionary.meal.appetizer}
          />
        );
      case Constants.MEAL.MAIN:
        return (
          <SelectedMealListItem
            key={`selected-meal-list-item-${Constants.MEAL.MAIN}-${passenger.id}`}
            className={className}
            passenger={passenger}
            meal={meal}
            mealType={Constants.MEAL.MAIN}
            label={Dictionary.meal.mainMeal}
          />
        );

      case Constants.MEAL.DESSERT:
        return (
          <SelectedMealListItem
            key={`selected-meal-list-item-${Constants.MEAL.DESSERT}-${passenger.id}`}
            className={className}
            passenger={passenger}
            meal={meal}
            mealType={Constants.MEAL.DESSERT}
            label={Dictionary.meal.dessert}
          />
        );
    }
  });

SelectedMealListItems.propTypes = {
  passenger: PropTypes.object,
  meals: PropTypes.object,
  className: PropTypes.string,
};

export default SelectedMealListItems;



// WEBPACK FOOTER //
// ./src/containers/meals/common/mealsList/SelectedMealListItems.js